// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__H8YIh","col":"styles_col__1iq1Z"};